module.exports = __webpack_public_path__ + "static/media/roshan2.5f57d362.jpg";